import { FC, useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import Image from "components/Image";

interface Props {
  data: string;
  icon?: TooltipIcons;
  height?: number;
  width?: number;
}

export type TooltipIcons = "lock" | "questionMark" | null;

export const IconTooltip: FC<Props> = ({ data, icon, height, width }) => {
  const iconLinks = {
    lock: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABSUlEQVRIie3TvUrDYBTG8f8JhC51cKmDdZLeh85+TO5uaZauegtKB4XSYhrMBThVKoj3oKObW7s4iOAHGdL0uEQo2vq29K2D5lkSXk6eXw4k8N8iswz7vl9K07QmIttABXgH7oFuoVA4bzQaL9bharW6p6oRsDRh5FFV98MwvJmmz5kBvcjQjqpuxHFcjOO46DjOpqpeAisicuV53tY0ncaNfd8vDYfDhww9aLfb9Qkvd6iqR8Cz67qVZrP59FOvceM0TWsZ2pmEAgRBcAx0geUkSWqmXiMsIjsAqnpqmgVOsuvu3DCwDuC67p1pcDAY3Ga3FRtwEaDVar2ZBqMoeh19Zl54Ifn2VWe/QwCsWjL6quqFYXg9ejhu4zOLKEBZRIKvh+PgskX0M2vTwL+SHM7hHM7hvwH3F+D0jLCqepbxnoh4FvvyzJYP8RhrounhCHMAAAAASUVORK5CYII=",
    questionMark:
      "data:image/png;base64,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",
  };

  const imageSRC = icon ? iconLinks[icon] : iconLinks["lock"];

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <>
      <Image
        src={imageSRC}
        height={height}
        width={width}
        alt="tooltip icon"
        data-tip={data}
      />
      <Tooltip />
    </>
  );
};

const Tooltip = () => {
  return <ReactTooltip html backgroundColor="#333" effect="solid" />;
};

IconTooltip.defaultProps = {
  icon: "questionMark",
  height: 20,
  width: 20,
};
